import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {Bullet as DXBullet} from 'devextreme-react/bullet';


export default class Bullet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
            target: this.props.target
        };
    }

    // UNSAFE_componentWillReceiveProps(props) {
    //     if (
    //         (this.state.value !== props.value)
    //         || (this.state.target !== props.target)
    //     ) {
    //         this.setState({
    //             value: props.value,
    //             target: props.target,
    //         })
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState){
        if ((nextProps.value !== prevState.value) || (nextProps.target !== prevState.target)) {
            return {
                value: nextProps.value,
                target: nextProps.target,
            };
        }
        return null;
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXBullet
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                value={this.state.value}
                target={this.state.target}
            />
        )
    }
}

/*
export default class Bullet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
            target: this.props.target
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ((this.state.value !== nextProps.value) || (this.state.target !== nextProps.target))
    //     if (
    //         (this.state.value !== nextProps.value)
    //         || (this.state.target !== nextProps.target)
    //     ) {
    //         this.setState({
    //             value: props.value,
    //             target: props.target,
    //         })
    //     }
    //     !shallowEqual(instance.props, nextProps) ||
    // !shallowEqual(instance.state, nextState)
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        return (
            <DXBullet
                {...omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                value={this.state.value}
                target={this.state.target}
            />
        )
    }
}
*/

/*
const Bullet = (props) => {
    const dataAttributes = {};
    if(props.loading_state && props.loading_state.is_loading) {
        dataAttributes['data-dash-is-loading'] = true;
    }

    const [value, setValue] = useState(0);
    const [target, setTarget] = useState(0);

    return (
        <DXBullet
            {...omit(['loading_state', 'setProps'], props)}
            {...dataAttributes}
            value={value}
            target={target}
        />
    );
};
*/

Bullet.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    color: PropTypes.string,
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    endScaleValue: PropTypes.number,
    margin: PropTypes.object,
    onDisposing: PropTypes.func,
    onDrawn: PropTypes.func,
    onExported: PropTypes.func,
    onExporting: PropTypes.func,
    onFileSaving: PropTypes.func,
    onIncidentOccurred: PropTypes.func,
    onInitialized: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onTooltipHidden: PropTypes.func,
    onTooltipShown: PropTypes.func,
    pathModified: PropTypes.bool,
    rtlEnabled: PropTypes.bool,
    showTarget: PropTypes.bool,
    showZeroLevel: PropTypes.bool,
    size: PropTypes.object,
    startScaleValue: PropTypes.number,
    target: PropTypes.number,
    targetColor: PropTypes.string,
    targetWidth: PropTypes.number,
    theme: PropTypes.oneOf(['generic.dark', 'generic.light', 'generic.contrast', 'ios7.default', 'generic.carmine', 'generic.darkmoon', 'generic.darkviolet', 'generic.greenmist', 'generic.softblue', 'material.blue.light', 'material.lime.light', 'material.orange.light', 'material.purple.light', 'material.teal.light']),
    tooltip: PropTypes.object,
    value: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

Bullet.defaultProps = {
    color: '#e8c267',
    disabled: false,
    elementAttr: {},
    // endScaleValue: undefined,
    margin: {},
    onDisposing: null,
    onDrawn: null,
    onExported: null,
    onExporting: null,
    onFileSaving: null,
    onIncidentOccurred: null,
    onInitialized: null,
    onOptionChanged: null,
    onTooltipHidden: null,
    onTooltipShown: null,
    pathModified: false,
    rtlEnabled: false,
    showTarget: true,
    showZeroLevel: true,
    size: {},
    startScaleValue: 0,
    target: 0,
    targetColor: '#666666',
    targetWidth: 4,
    theme: 'generic.light',
    tooltip: {},
    value: 0
};

// export default Bullet;
